import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { filter, first, Observable } from 'rxjs';

@Injectable()
export abstract class ToastService {
  private translocoService = inject(TranslocoService);

  showError(key: string, params?: any): void {
    this.getAsyncTranslation(key, params).subscribe(msg => this.displayError(msg));
  }

  showSuccess(key: string, params?: any): void {
    this.getAsyncTranslation(key, params).subscribe(msg => this.displaySuccess(msg));
  }

  protected abstract displayError(message: string): void;
  protected abstract displaySuccess(message: string): void;

  private getAsyncTranslation(key: string, params?: any): Observable<string> {
    return this.translocoService.selectTranslate(key, params).pipe(
      filter(translation => translation !== key && Boolean(translation)),
      first()
    );
  }
}
